export class UsuarioSessao {
  constructor(
    public id: number,
    public nome: string,
    public login: string,
    public permissoes: string[],
    public token: string,
    public tokenExpiracao: Date
  ) {}
}
